/**
 * Masaüstünde ana süreç arayüze `webContents.send(kanal, veri)` ile olay
 * gönderiyor; preload bunları `onX(callback)` aboneliklerine çeviriyor. Web'de
 * iki taraf aynı sayfada: servisler olayı bu veri yoluna yazıyor, köprü
 * aboneliği buradan dinliyor. Kanal adları masaüstündekiyle aynı (CHANNELS).
 */

type Handler = (...args: unknown[]) => void;

const handlers = new Map<string, Set<Handler>>();

export function emit(channel: string, ...args: unknown[]): void {
  for (const handler of handlers.get(channel) ?? []) {
    try {
      handler(...args);
    } catch (err) {
      console.error(`[bus] ${channel} dinleyicisi hata verdi:`, err);
    }
  }
}

export function subscribe<A extends unknown[]>(channel: string, handler: (...args: A) => void): () => void {
  let set = handlers.get(channel);
  if (!set) handlers.set(channel, (set = new Set()));
  set.add(handler as Handler);
  return () => {
    set.delete(handler as Handler);
  };
}
